<template>
<div class="chapter">
<div class="inner_page">
<h1 class="sigilnotintoc sigil_not_in_toc"><br class="calibre1"/></h1>
<h1 class="sigilnotintoc sigil_not_in_toc" id="id00000"><br class="calibre1"/></h1>
<h1 class="sigilnotintoc" id="sigil_toc_id_1">The Brethren<br class="calibre1"/></h1>
<p class="calibre2" id="id00009">by H. Rider Haggard</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?6d7d4988